<div>
    <button mat-icon-button [matMenuTriggerFor]="menu">
        <img class="avatar-image" src="{{ userPhotoSourceUrl }}" />
    </button>
    <mat-menu #menu="matMenu" style="z-index: 100000">
        <button mat-menu-item (click)="toggleTheme()">
            <mat-icon class="material-symbols-outlined">contrast</mat-icon>
            <span>Toggle Theme</span>
        </button>
        <button *ngIf="appService.isLoggedIn && subdomain != 'admin' && appService.isMemberOfAdminRole()" mat-menu-item (click)="appService.goToSubdomain('admin')">
            <mat-icon class="material-symbols-outlined">crown</mat-icon>
            <span>Administration</span>
        </button>
        <button *ngIf="appService.isLoggedIn && subdomain != 'www'" mat-menu-item (click)="appService.goToSubdomain('www')">
            <mat-icon class="material-symbols-outlined">space_dashboard</mat-icon>
            <span>Lutz Angeles™</span>
        </button>
        <button *ngIf="appService.isLoggedIn && subdomain != 'mendls'" mat-menu-item (click)="appService.goToSubdomain('mendls')">
            <mat-icon class="material-symbols-outlined">storefront</mat-icon>
            <span>Mendls</span>
        </button>
        <button *ngIf="appService.isLoggedIn && subdomain != 'illustra' && appService.isMemberOfAdminRole()" mat-menu-item (click)="appService.goToSubdomain('illustra')">
            <mat-icon class="material-symbols-outlined">flare</mat-icon>
            <span>Illustra</span>
        </button>
        <!--
        <button *ngIf="!appService.isLoggedIn" mat-menu-item (click)="appService.navigateTo('login', '')">
            <mat-icon class="material-symbols-outlined">login</mat-icon>
            <span>Login</span>
        </button>
        -->
        <button *ngIf="appService.isLoggedIn" mat-menu-item (click)="logout()">
            <mat-icon class="material-symbols-outlined">logout</mat-icon>
            <span>Logout</span>
        </button>
    </mat-menu>
</div>
